import { useEffect } from "react";

function useScrollTopClass(className = "BodyOnTop") {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        document.body.classList.add(className);
        document.body.classList.remove('notTOP');
      } else {
        document.body.classList.remove(className);
        document.body.classList.add('notTOP');
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // 🔹 Ejecuta la función inmediatamente para evaluar el estado inicial

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [className]);
}

export default useScrollTopClass;